import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa en cocina?',
    a: 'No. El Tomo I está diseñado desde cero. Si nunca hiciste un sándwich de miga profesional, en el Capítulo 1 ya vas a entender la técnica completa. Si ya tenés experiencia, vas a descubrir los secretos que te faltaban.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Después de confirmar el pago recibís un email con el link de descarga en menos de 5 minutos. Podés verlo desde el celular, tablet o computadora.'
  }, {
    q: '¿Funciona para vender en mi ciudad?',
    a: 'Sí. El método está diseñado para el mercado argentino. Los precios, los proveedores sugeridos y las estrategias de WhatsApp están pensados para la realidad de cada provincia.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, sin preguntas. Si no te gusta, te devolvemos el 100% del dinero. Así de simple.'
  }, {
    q: '¿Qué lo diferencia de un tutorial de YouTube?',
    a: 'YouTube te da recetas sueltas. Miga Master Pro te da un sistema completo: técnica + negocio + costos + ventas. Todo en un solo lugar, ordenado y listo para ejecutar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 bg-brand-cream" data-id="element-116">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-117">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-brand-dark mb-8" data-id="element-118">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3" data-id="element-119">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-brand-lightGray overflow-hidden" data-id="element-120">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-121">
                <span className="font-bold text-brand-dark text-lg pr-4" data-id="element-122">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-123">
                  <ExpandMoreIcon className="text-brand-gold" data-id="element-124" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-125">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-126">
                    <div className="px-6 pb-5 text-brand-gray border-t border-gray-50 pt-4" data-id="element-127">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}